import React, { Component } from 'react'
import { connect } from 'react-redux'
import * as postActions from '../../store/action/post'
import { ToastContainer, toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css';
import { Field, reduxForm, formValueSelector, change } from 'redux-form'
import * as fileActions from '../../store/action/file'
import { validateCreatePostForm } from '../../utils/formValidation'
import * as _ from 'lodash'
import TitleTab from 'src/components/posts/tab/title-tab'
import TitleAI from 'src/components/posts/tab/title-ai'
import DescriptionTab from 'src/components/posts/tab/description-tab'
import EditorTypeTab from 'src/components/posts/tab/editortype-tab'
import ContentTab from 'src/components/posts/tab/content-tab'
import ContentMobiTab from 'src/components/posts/tab/content-m-tab'
import ThumbnailTab from 'src/components/posts/tab/thumbnail-tab'
import CoverTab from 'src/components/posts/tab/cover-tab'
import OptionsTab from 'src/components/posts/tab/options-tab'
import ShareEditPermissionTab from 'src/components/posts/tab/ShareEditPermissionTab';
import CategoryTab from 'src/components/posts/tab/category-tab'
import TagTab from 'src/components/posts/tab/tag'
import DimensionTab from 'src/components/posts/tab/dimension'
import PRTab from 'src/components/posts/tab/pr-tab'
import ContentCreatorTab from 'src/components/posts/tab/content-creator-tab'
import GioXuatBanTab from 'src/components/posts/tab/gio-xuat-ban-tab'
import ActionsPost from '../../components/posts/actions-post'
import localStorage from '../../utils/local-storage'
import checkCondition from '../../utils/check-condition'
import "./content.css?v=1.5";
import ReactDOM from "react-dom";
import RoyaltiesTab from '../../components/posts/tab/royalties-tab';
import localStore from "src/utils/local-storage";

import ScreenSize from 'src/services/screenSize';
import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css
import ApiService from "../../services/ApiService";
import CkService from "src/services/CkService";
import decodeUriComponent from 'decode-uri-component';
import { removeUselessChar, udpateLogPost, getYear, getMonth, getDate } from "../../utils/common"
import slug from '@sindresorhus/slugify'
import { replace } from 'lodash';
import IdleTimer from 'react-idle-timer';

import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import moment from 'moment';
import { convertChannelIdToName } from 'src/utils/convert-channel';

const toHtmlEntities = str => {
  return String(str).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
}

const CONTENT_TYPE_IMG = ["image/jpg", "image/jpeg", "image/gif", "image/png"];

const extractDomain = url => {
  var hostname;
  if (url.indexOf("//") > -1) {
      hostname = url.split('/')[2];
  }
  else {
      hostname = url.split('/')[0];
  }

  hostname = hostname.split(':')[0];
  hostname = hostname.split('?')[0];
  return hostname;
}

const htmlDecode = (input) => {
  let e = document.createElement('textarea');
  e.innerHTML = input;
  // handle case of empty input
  return e.childNodes.length === 0 ? "" : e.childNodes[0].nodeValue;
}

const FE_DOMAIN = extractDomain(process.env.REACT_APP_FE_URL);


const validate = values => {
  return validateCreatePostForm(values, false);
};

const isExternalSrc = (src, channel_domain) => {
  // nếu không tick chuyên mục - không có channel domain thì không check external image
  if(!channel_domain) return false;
  const DOMAIN = channel_domain ? [channel_domain] : process.env.REACT_APP_INTERNAL_DOMAIN.split(",");
  const cdnRegex = RegExp(DOMAIN.map(s => s.trim().replace('.', '\\.')).join('|'));
  return !cdnRegex.test(src)
};
const getPathFromUrl = url => url;

const _user = localStorage.get("_user");
class PostContent extends Component {
  intervalID = 0;
  layoutPC3 = false;
  idleTimer = null;
  constructor(props) {
    super(props);
    this.state = {
      idleTime: 0,
      idleTimeMax: 15,
      showModal: false,
      isTimedOut: false,
      pass: false,
      createdPost: false,
      selectedFile: {},
      willChangePage: false,
      isLocking: false,
      currentPost: null,
      listPosttype: null, currentTab: 1, currentStatus: 'drafting', getEditorData: false,
      typepage: props.typepage, clickingTab: true,
      listTab: {
        title: { tabName: 'title', error: true, tagNumber: 1, classname: ['nav-link', ''], isPrerequisite: true, isSEOCheck: false, requireText: 'Tiêu đề bài viết' },
        title_ai: { tabName: 'title_ai', error: true, tagNumber: 1, classname: ['nav-link', ''], isPrerequisite: true, isSEOCheck: false, requireText: 'Tiêu đề bài viết AI' },
        title_google: { tabName: 'title_google', error: true, tagNumber: 16, classname: ['nav-link', ''], isPrerequisite: true, isSEOCheck: true, requireText: 'Tiêu đề Google' },
        keyword: { tabName: 'keyword', error: true, tagNumber: 18, classname: ['nav-link', ''], isPrerequisite: true, isSEOCheck: true, requireText: 'Keywords' },
        description: { tabName: 'description', error: true, tagNumber: 2, classname: ['nav-link', ''], isPrerequisite: true, isSEOCheck: false, requireText: 'Tóm tắt nội dung' },
        description_google: { tabName: 'description_google', error: true, tagNumber: 17, classname: ['nav-link', ''], isPrerequisite: true, isSEOCheck: true, requireText: 'Tóm tắt Google' },
        content: { tabName: 'content', error: true, tagNumber: 3, classname: ['nav-link', ''], isPrerequisite: true, isSEOCheck: false, requireText: 'Nội dung' },
        content_m: { tabName: 'content_m', error: false, tagNumber: 13, classname: ['nav-link', ''], isPrerequisite: true, isSEOCheck: false, requireText: 'Nội dung Mobile' },
        content_internal_link: { tabName: 'content_internal_link', error: true, tagNumber: 15, classname: ['nav-link', ''], isPrerequisite: true, isSEOCheck: true, requireText: 'Chèn 1-3 Internal link' },
        content_sub_title: { tabName: 'content_sub_title', error: true, tagNumber: 19, classname: ['nav-link', ''], isPrerequisite: false, isSEOCheck: true, requireText: 'Chèn Sub title - Sub heading' },
        contentlink: { tabName: 'contentlink', error: false, tagNumber: 10, classname: ['nav-link', ''], isPrerequisite: true, isSEOCheck: false, requireText: 'Nội dung External link' },
        externalimage: { tabName: 'externalimage', error: false, tagNumber: 11, classname: ['nav-link', ''], isPrerequisite: true, isSEOCheck: false, requireText: 'External Image' },
        nhaycam: { tabName: 'nhaycam', error: false, tagNumber: 11, classname: ['nav-link', ''], isPrerequisite: true, isSEOCheck: false, requireText: 'Từ nhạy cảm' },
        thumbnail: { tabName: 'thumbnail', error: true, tagNumber: 4, classname: ['nav-link', ''], isPrerequisite: true, isSEOCheck: false, requireText: 'Thumbnail' },
        category: { tabName: 'category', error: true, tagNumber: 5, classname: ['nav-link', ''], isPrerequisite: true, isSEOCheck: false, requireText: 'Chuyên mục' },
        tag: { tabName: 'tag', error: true, tagNumber: 6, classname: ['nav-link', ''], isPrerequisite: true, isSEOCheck: false, requireText: 'Tag' },
        penname: { tabName: 'penname', error: true, tagNumber: 7, classname: ['nav-link', ''], isPrerequisite: true, isSEOCheck: false, requireText: 'Bút danh' },
        money: { tabName: 'money', error: true, tagNumber: 8, classname: ['nav-link', 'tab-require-status-success'], isPrerequisite: true, isSEOCheck: false, requireText: 'Chấm nhuận' },
        log: { tabName: 'log', error: false, tagNumber: 9, classname: ['nav-link', 'tab-require-status-success'], isPrerequisite: true, isSEOCheck: false, requireText: 'Nhật ký' },
        videoratio: { tabName: 'videoratio', error: false, tagNumber: 12, classname: ['nav-link', ''], isPrerequisite: true, isSEOCheck: false, requireText: 'Video Ratio' },
        pr: { tabName: 'pr', error: true, tagNumber: 14, classname: ['nav-link', ''], isPrerequisite: true, isSEOCheck: false, requireText: 'Thông tin PR' },
        // cover: { tabName: 'cover', error: false,
        // tagNumber: 10, classname: ['nav-link',
        // 'tab-require-status-success'],
        // isPrerequisite: true, isSEOCheck:
        // false, requireText: 'Ảnh Cover' },
      },
      categoryHeight: 0,
      canAccess: false,
      currentId: "",
      isPr: false,
      scheduleDate: null,
      postRevision: null,
      nhaycamInfo: null,
      editor_type: 'normal',
      pr_type: 0,
      showExitPrompt: props.typepage == "edit" ? props.showExitPrompt : false,
      saveStatus: false,
      showModalError: false,
      listImageError: [],
      checkExternalIMGError: false
    };
    this.layoutPC3 = ScreenSize.isBiggerThan1366;
    this.idleTimer = null;
    this.onAction = this._onAction.bind(this);
    this.onActive = this._onActive.bind(this);
    this.onIdle = this._onIdle.bind(this);
  }
  setShowExitPrompt = (state) => {
    if(this.props.typepage == "edit" && this.props.setShowExitPrompt){
      this.setState({"showExitPrompt": state});
      this.props.setShowExitPrompt(state);
    }
    
  }
  onFocus = e => {
    // clearTimeout
    console.log('onFocus tab edit');
    console.log(localStore.get('_tabs'));
    console.log(window.location.pathname);
    if(!localStore.activeTab() && window.location.pathname.includes("/posts/edit/") && this.props.typepage == "edit" && !this.state.showExitPrompt){
      this.setState({showModal: true})
      clearInterval(this.intervalID);
      clearInterval(this.intervalID2);
    }
  }
  _onAction(e) {
    this.setState({isTimedOut: false})
  }
 
  _onActive(e) {
    this.setState({isTimedOut: false})
  }

  _onIdle(e) {
    this.setState({showModal: true})
    clearInterval(this.intervalID);
    clearInterval(this.intervalID2);
  }

  handleClose(e) {
    console.log(e);
    // let { currentId, canAccess } = this.state;
    // if (canAccess) {
    //   localStorage.remove("_current_id");
    //   setTimeout(() => {
    //     if (currentId) {
    //       PostService.updatelock({
    //         editing_status: false,
    //         editing: null,
    //         start_editing: null,
    //         id: currentId,
    //       });
    //     }
    //   }, 500);
    // }
    location.reload();
  }

  componentCleanup(el) { // this will hold the cleanup code
      // whatever you want to do when the component is unmounted or page refreshes
      console.log("unmount");
      clearInterval(el.intervalID);
      clearInterval(el.intervalID2);
      el.handleLockPost(false);
  }

  componentDidMount() {
    // console.log("didmount");
    window.addEventListener('beforeunload', () => {
      this.componentCleanup(this);
    });
    window.addEventListener("focus", this.onFocus);
    const { content, post, router } = this.props;
    // console.log(post);
    const query = new URLSearchParams(window.location.search);
    const editor_type = query.get('editor_type') ? query.get('editor_type') : post.currentPost.editor_type;
    // console.log();
    content.editor_type = editor_type;
    // khởi tạo old_posttype để lưu lại previous posttype của currentPost
    content.old_posttype = content.posttype;
    
    this.setState({ currentPost: content, canAccess: true, isPr: content.is_pr, editor_type, pr_type: content.pr_type ? content.pr_type : 0 }, () => {

      this.setDataForm(content);
      // this.intervalID = setInterval(() => {
      //   this.checkRequireData(content, 0);
      // }, 1500);

      //auto save 90s
      this.intervalID2 = setInterval(() => {
        if (post.currentPost.posttype.type_code == 'draft') {
          let passCondition = this.checkRequireData(post.currentPost, post.currentTabPost);
          this.actionForPost(passCondition, false);
          toast.success('Đã lưu tự động');
        }
      }, 60000);
    });

    if (this.props.post && this.props.post.currentPost && this.props.post.currentPost.id) {
      ApiService.get(`/post-revisions?post=${this.props.post.currentPost.id}`).then(data => {
        if (data && data[0]) {
          this.setState({
            postRevision: data[0]
          });
        } else {
          ApiService.post(`/post-revisions`, {post: this.props.post.currentPost.id}).then(data2 => {
            this.setState({
              postRevision: data2
            });
          });
        }
      });
    }
    
  }

  componentWillUnmount() {
    this.componentCleanup();
    window.removeEventListener('beforeunload', this.componentCleanup);
    window.removeEventListener("onfocus", this.onFocus);
    // if (this.state.canAccess) {
    // }
  }
  UNSAFE_componentWillUpdate(nextProps, nextState){
    if(nextState.currentPost !=  this.state.currentPost){
      this.checkRequireData(nextState.currentPost, 0);
    }
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    const { post: nextPost } = nextProps;
    const { post } = this.props;

    if (post.updatePostStatus !== nextPost.updatePostStatus && nextPost.updatePostStatus === 2) {
      if (!this.state.clickingTab) {
        if (['special', 'mini'].includes(post.currentPost.editor_type) || (post.currentPost.posttype.type_code === 'draft' && post.currentPost.old_posttype.type_code === 'draft')) {
          this.handleLockPost(true, post.currentPost);
          toast.success('Đã cập nhật bài viết.');
        } else {
          if (!post.currentPost.is_live) {
            this.goOutThispage('', '/posts');
            console.log('redirect happened');
          } else {
            toast.success('Đã thêm nội dung');
          }

        }
      } else {
        // this.handleLockPost(true)
      }
    }

    if (post.currentTabPost !== nextPost.currentTabPost) {
      if (this.state.currentPost && this.state.currentPost.posttype.type_code === "ready") {
        nextPost.currentPost.currentPostType = "ready"
      }
      this.setState({ currentPost: nextPost.currentPost, currentTab: nextPost.currentTabPost }, () => {
        let passCondition = this.checkRequireData(nextPost.currentPost, post.currentTabPost);
        this.actionForPost(passCondition, false);
      })
    }

    if (post.createPostStatus !== nextPost.createPostStatus && nextPost.createPostStatus === 2) {
      let currentPost = nextPost.currentPost;
      localStorage.set('_newPost', currentPost);
      this.setState({ currentPost });
      toast.success("Đã lưu");
      // thay url bằng increment_id
      if(currentPost && currentPost._id){
        window.history.replaceState({},
          "/posts/new", `/posts/edit/${currentPost._id}`);
        // console.log(this.state.currentPost);
        this.handleLockPost(true, currentPost);
      }
    }
    if(nextPost.createPostStatus === 3) {
      toast.error(nextPost.error.message);
    }
     
    if(nextPost != post){
      this.checkRequireData(nextPost.currentPost, 0);
    }
    // if (nextPost.currentPost.posttype.type_code == 'draft') {
    //   // this.checkRequireData(nextPost.currentPost, 0);
    //   // let passCondition = this.checkRequireData(nextPost.currentPost, nextPost.currentTabPost);
    //   // this.actionForPost(passCondition, false);
    //   // toast.success('Đã lưu tự động');
    // }
  }

  goOutThispage(message, page) {
    if (this.state.canAccess) {
      // 
    }
    // this.props.router.push(page);
    this.handleLockPost(false)
    setTimeout(() => {
      window.location.href = page;
    }, 500);
  }

  handleLockPost(isLock, currentPost) {
    console.log("handleLockPost");
    let data = !isLock ? {
      'editing': null,
      'editing_status': false,
      'start_editing': null
    } : {
        'editing': localStorage.get("_user"),
        'editing_status': true,
        'start_editing': new Date()
      }
    if(currentPost && currentPost._id){
      console.log("lockpost");
      ApiService.put(`/posts/${currentPost._id}`, data);
    }else{
      if (this.state.currentPost && this.state.currentPost._id) {
        console.log("lockpost");
        ApiService.put(`/posts/${this.state.currentPost._id}`, data);
      }
    }
    

  }
  setDataForm(content) {
    this.props.dispatch(change('formPostEdit', 'title', content.title));
    this.props.dispatch(change('formPostEdit', 'url', (content.url ? content.url : "")));
    this.props.dispatch(change('formPostEdit', 'keyword', content.keyword));
    this.props.dispatch(change('formPostEdit', 'sourcename', content.sourcename));
    this.props.dispatch(change('formPostEdit', 'title_google', content.title_google));
    this.props.dispatch(change('formPostEdit', 'description_google', content.description_google));
    this.props.dispatch(change('formPostEdit', 'description', content.description));
    this.props.dispatch(change('formPostEdit', 'prprice', content.prprice));
    this.props.dispatch(change('formPostEdit', 'prdiscount', content.prdiscount));
    this.props.dispatch(change('formPostEdit', 'title_ai', content.title_ai));
    this.props.dispatch(change('formPostEdit', 'description_ai', content.description_ai));
  }

  checkRequireData = async (contentPost, tab = 0) => {
    // console.log('check requireData');
    let { listTab } = this.state;
    let classError = 'tab-require-status-error';
    let classSuccess = 'tab-require-status-success';
    for (const key in listTab) {

      if (listTab.hasOwnProperty(key) && (listTab[key].tagNumber == tab || tab == 0)) {
        const check = await checkCondition({
          type: listTab[key].tabName,
          content: contentPost,
          ignoreList: [
            ...(this.state.isPr ? ['penname'] : []),
            ...((this.state.editor_type != 'video' && this.state.editor_type != 'short')  ? ['videoratio'] : []),
            ...((this.state.currentPost && this.state.currentPost.pr_type && this.state.currentPost.pr_type == 0 ? ['pr'] : []))
          ]
        });
        if (check) {
          if (typeof check === "object") {
            const { info } = check;
            listTab[key].info = info;
          } else {
            listTab[key].error = true;
            if(listTab[key].classname[1]){
              listTab[key].classname[1] = classError;
            }
          }
          
          if(key === "videoratio"){
            listTab[key].error = false;
            listTab[key].classname[1] = classError;
            listTab[key].classname[2] = 'require-status-warning';
            // console.log(listTab[key]);
          }
          if(key === "pr"){
            listTab[key].error = true;
            listTab[key].classname[1] = classError;
          }
        } else {
          if (listTab[key].info) {
            listTab[key].info = undefined;
          }
          listTab[key].error = false;
          listTab[key].classname[1] = classSuccess;
        }
      }
    }
    this.setState({ listTab });

    if (listTab.nhaycam.info || listTab.nhaycam.info === undefined) {
      this.setState({nhaycamInfo: listTab.nhaycam.info});
    } else {
      this.setState({nhaycamInfo: null});
    }
    // filter tab !error & isPrerequisite
    const listTabPassCondition = _.filter(listTab, { 'error': false, 'isPrerequisite': true });
    const listTabIsPrerequisite = _.filter(listTab, { 'isPrerequisite': true });
    this.state.pass = listTabPassCondition.length === listTabIsPrerequisite.length;

    return listTabPassCondition;
  }

  goTab(tab) {
    const { post: { currentPost } } = this.props;
    const tabactive = document.getElementById("vert-tabs-"+this.state.currentTab);
    // console.log(tabactive);
    if(tabactive){
      tabactive.classList.remove('active','show');
    }
    if (tab !== this.state.currentTab) {
      this.setState({ clickingTab: true });
      this.props.changeTab(tab);
    }
  }

  updatePost() {
    const { post: { currentPost } } = this.props;
    this.actionBeforeUpdatePost(currentPost);
  }

  savePost(status) {
    console.log('savePost')
    const { post: { currentPost }, config: { listPosttyle } } = this.props;
    const posttype = _.find(listPosttyle, { 'type_code': status });

    let { currentStatus } = this.state;
    currentStatus = posttype.type_code;
    this.setState({ currentStatus });
    currentPost.posttype = posttype._id;
    this.actionBeforeUpdatePost(currentPost);
  }

  updateStatusFromClickButton = async (data) => {
    console.log("updateStatusFromClickButton");
    this.setState({ clickingTab: false });
    this.setState({saveStatus : true});
    // console.log("set state save true");
    const { posttype, time, should_check_condition, new_action, currentPostType } = data
    let { post: { currentPost }, fields } = this.props;
    const { listTab } = this.state;

    const { title, url, title_google, keyword, description, description_google, sourcename, prprice, prdiscount } = fields;
    currentPost.keyword = keyword ? keyword : ''
    currentPost.title_google = title_google ? removeUselessChar(title_google) : ''
    currentPost.url = url ? url : ''
    currentPost.title = title ? removeUselessChar(title) : ''
    currentPost.description = description ? removeUselessChar(description) : ''
    currentPost.description_google = description_google ? removeUselessChar(description_google) : ''
    currentPost.sourcename = sourcename ? sourcename : ''
    currentPost.clickButton = true;
    currentPost.log_action = `${currentPost.log_action}${new_action}`;
    currentPost.currentPostType = currentPostType;
    let passCondition = await this.checkRequireData(currentPost, 0);

    let content = currentPost.content;

    await this.handleImageSrc(currentPost)
      .then(post => {
        if (posttype.type_code === 'ready' || posttype.type_code === 'schedule') {
          return this.handleImageAlt(post);
        }

        return Promise.resolve(post)
      })
      .then(this.handleLinks)
      .then(updatedPost => {

        // update content
        currentPost = updatedPost;
        const listTabIsPrerequisite = _.filter(listTab, { 'isPrerequisite': true });

        if (currentPost.posttype.type_code !== 'draft') {
          if (should_check_condition == "yes") {
            if (passCondition.length < listTabIsPrerequisite.length) {
              toast.error('Vui lòng kiểm tra lại điều kiện')
            } else {
              currentPost.old_posttype = currentPost.posttype;
              currentPost.posttype = posttype;
              if (time) {
                currentPost.scheduleAt = time;
              }
              
  
              this.actionBeforeUpdatePost(currentPost);
            }
          } else {
            currentPost.old_posttype = currentPost.posttype;
            currentPost.posttype = posttype;
            if (time)
              currentPost.scheduleAt = time;
            this.actionBeforeUpdatePost(currentPost);
          }
        }
  
        if (currentPost.posttype.type_code === 'draft') {
          if (posttype.type_code === 'trash') {
            currentPost.old_posttype = currentPost.posttype;
            currentPost.posttype = posttype;
            this.actionBeforeUpdatePost(currentPost);
          } else if (posttype.type_code !== 'draft') {
            if (passCondition.length === listTabIsPrerequisite.length) {
              currentPost.old_posttype = currentPost.posttype;
              currentPost.posttype = posttype;
              this.actionBeforeUpdatePost(currentPost);
            } else {
              toast.error('Vui lòng kiểm tra lại điều kiện')
            }
          } else {
            if (localStorage.get('_newPost')) {
              localStorage.set('_newPost', currentPost);
            }
            this.actionForPost(passCondition, true);
          }
  
        }
      })
      .catch(err => {
        console.log('error update content:', err);
      })
    
    this.setState({saveStatus: false});
  }

  handleLinks(currentPost){
    const r = new RegExp(`href="${FE_DOMAIN.replace('.', '\\.')}([^"]*)"`);
    currentPost.content = currentPost.content.replace(r, `href=\"//${FE_DOMAIN}$1\"`);
    return Promise.resolve(currentPost);
  }

  handleImageSrc(currentPost) {
    let content = currentPost.content
    const tmp_id = currentPost.tmp_id;
    const fy = getYear(currentPost.createdAt);
    const fm = getMonth(currentPost.createdAt);
    const fdate = getDate(currentPost.createdAt);
    const title = currentPost.title;
    const type = currentPost.editor_type
    const channel = this.props.config.channels ? this.props.config.channels.filter(obj => obj.increment_id == currentPost.channel) : null;
    const channel_domain = (channel && channel.length > 0 && channel[0] && channel[0].domain) ? channel[0].domain : null;
    return new Promise((resolve, reject) => {
      const imgRegex = /<img[^>]*src="([^"]+)"[^>]*>/gm;
      const regResults = Array.from(content.matchAll(imgRegex));
      if(regResults) {
        Promise.allSettled( regResults.map((match, index) => {
          return new Promise(async (rsl, rjt) => {
            const img = match[0];
            const src = match[1];
            if(isExternalSrc(src, channel_domain)){
              console.log('external image:', src);
              const decodeSrc = decodeUriComponent(getPathFromUrl(htmlDecode(src)));
              let fileName = slug((title || tmp_id) + ' ' + index) + this.checkExtensions(decodeSrc);
              // console.log('fileName', fileName);
              await this.readImage(decodeSrc)
                .then(myBase64 => {                  
                  const fd = new FormData()
                  const file = new File([this.b64toBlob(myBase64)], fileName);
                  fd.append('upload', file);
                  fd.append('fy',fy);
                  fd.append('fm',fm);
                  fd.append('fd',fdate);
                  console.log('fd', fd);
                  return CkService.upload(
                    `/s3/core/connector/php/connector.php?command=QuickUpload&type=Images&responseType=json&currentFolder=&id=${tmp_id}&editorType=${type}&fy=${fy}&fm=${fm}&fd=${fdate}&channel=${convertChannelIdToName(currentPost.channel, this.props.config.channels)}`,
                    fd
                  )
                })
                .then(result => {
                  console.log('external image uploaded', result);
                  let fileResult = result.data;
                  let newSrc = encodeURI(fileResult.url);
                  rsl({
                    replacing: src,
                    replaceBy: newSrc
                  })
                })
                .catch(err => {
                  console.log('error upload external image: ', err);
                  rjt(err);
                })
  
            } else {
              const newSrc = decodeUriComponent(src);
              rsl({
                replacing: src,
                replaceBy: newSrc
              })
            }
          })
  
        }))
        .then(results => {
          results.forEach(result => {
            const {status, value, reason} = result;
            // Ignore rejections
            if(status === 'fulfilled') {
              const {replacing, replaceBy} = value;
              if(replacing !== replaceBy) {
                content = content.replace(replacing, replaceBy);
              }
            }
          });
          currentPost.content = content;
          console.log('resolve img src');
          resolve(currentPost);
        })
      } else {
        resolve(currentPost);
      }
      
    })
  }

  handleImageAlt(currentPost) {
    const title = currentPost.title;
    let content = currentPost.content;
    let content_m = currentPost.content_m;
    let newPost = currentPost;
    const imgRegex = /<img\s+[^>]+>/gm;
    if(content){
      newPost = new Promise((resolve, reject) => {
        if(content.match(imgRegex)) {
          content.match(imgRegex).forEach((img, index) => {
            if (!img.includes(`alt="`)) {
              const alt = toHtmlEntities(`${title} Ảnh ${index + 1}`);
              const newImage  = img.replace('<img', `<img alt="${alt}"`);
              content = content.replace(img, newImage);
            }
          });
          currentPost.content = content;
        }
        console.log('resolve img alt');
        resolve(currentPost);
      });
    }
    if(content_m){
      newPost = new Promise((resolve, reject) => {
        if(content_m.match(imgRegex)) {
          content_m.match(imgRegex).forEach((img, index) => {
            if (!img.includes(`alt="`)) {
              const alt = toHtmlEntities(`${title} Ảnh ${index + 1}`);
              const newImage  = img.replace('<img', `<img alt="${alt}"`);
              content_m = content_m.replace(img, newImage);
            }
          });
          currentPost.content_m = content_m;
        }
        console.log('resolve img alt');
        resolve(currentPost);
      });
    }
    
    return newPost;
  }

  checkExtensions(url) {
    if (url.includes('.jpg')) {
      return '.jpg'
    } else if (url.includes('jpeg')) {
      return '.jpeg'
    } else if (url.includes('.png')) {
      return '.png'
    } else {
      return '.jpg'
    }
  }


  b64toBlob(b64Data, contentType = "", sliceSize = 512) {
    b64Data = _.split(b64Data, ';base64,');
    const byteCharacters = atob(b64Data[1]);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);

      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    const blob = new Blob(byteArrays, { type: contentType });
    return blob;
  }

  toDataUrl(url, callback) {
    let xhr = new XMLHttpRequest();
    xhr.onload = function () {
      let reader = new FileReader();
      reader.onloadend = function () {
        callback(reader.result);
      }
      reader.readAsDataURL(xhr.response);
    };
    xhr.open('GET', url);
    xhr.responseType = 'blob';
    xhr.send();
  }

  readImage(url) {
    return new Promise((resolve, reject) => {
      const client = new XMLHttpRequest();
      client.open("GET", url);
      client.onerror = () => {
        this.setState({showModalError: true, checkExternalIMGError: true, listImageError: [...this.state.listImageError, url]});
        return;
      };
      client.send();

      client.onreadystatechange = () => {
        if (client.readyState === client.HEADERS_RECEIVED) {
          const contentType = client.getResponseHeader("Content-Type");
          let xhr = new XMLHttpRequest();
          xhr.onload = () => {
            let reader = new FileReader();
            reader.onloadend = () => {
              resolve(reader.result);
            }           
            reader.onerror = () =>{
              this.setState({showModalError: true, checkExternalIMGError: true, listImageError: [...this.state.listImageError, url]});
              reject('error read file');
            }
            reader.readAsDataURL(xhr.response);
          };
          xhr.onerror = () => {
            this.setState({showModalError: true, checkExternalIMGError: true, listImageError: [...this.state.listImageError, url]});            
            reject('error read file');
          };
          xhr.open('GET', url);
          if (CONTENT_TYPE_IMG.includes(contentType)) {
            // nếu là jpg hay png thì down trực tiếp
            console.log("load jpg png jpeg gif")
          }
          else{
            // ngược lại thêm no-cache
            console.log("load webp")
            xhr.setRequestHeader("Accept", "image/png,image/*;q=0.8,*/*;q=0.5");
            xhr.setRequestHeader("Cache-Control", "no-cache, no-store, must-revalidate");
          }
          client.abort()
          xhr.responseType = 'blob';
          xhr.send();
        }
      };
    })
  }

  genePostUrl(currentPost) {
    let url = "/";
    if (currentPost.primary_category) {
      url += currentPost.primary_category.url + '/';
    }
    if (currentPost.url) {
      url += currentPost.url;
    }
    const min = 1;
    const max = 9;
    const rand = Math.floor(Math.random() * (max - min + 1)) + min;
    let tmp_increment_id = moment().format('YYYYMMDDHHmmssSSS');
    tmp_increment_id = `${tmp_increment_id}${rand}`;
    return {
      'url': url.toLowerCase(),
      'increment_id': tmp_increment_id
    }
    // url += moment().format('YYYYMMDDhmmss');
    // // url += _user.increment_id || _user._id;
    // // console.log(url);

    // return url;
  }

  actionBeforeUpdatePost(currentPost) {
    console.log("actionBeforeUpdatePost");
    // neu bai post sap dang,  set current user vao publisher chi lan dau lan sau ko update
    if (currentPost.posttype.type_code == "ready") {
      if (!currentPost.publisher) {
        currentPost.publisher = localStorage.get("_user");
      }

      if (currentPost.currentPostType !== "ready") {
        // không cập nhật lại thời gian publish cho bài đã đăng       
        // currentPost.publishedAt = new Date();
        if (currentPost.pr_type == 0) {
          this.updateStatusTongHop(currentPost);
        }
      }
    }
    // neu bai post len lich,  update current user vao 
    if (currentPost.posttype.type_code == "schedule") {
      currentPost.publisher = localStorage.get("_user");
      if (currentPost.pr_type == 0) {
        this.updateStatusTongHop(currentPost);
      }
    }

    let datagenePostUrl = this.genePostUrl(currentPost);
    if (currentPost.increment_id && currentPost.increment_id != 0) {
      currentPost.post_url = datagenePostUrl.url + '-' + currentPost.increment_id + '.html';
    } else {
      currentPost.post_url = datagenePostUrl.url + '-' + datagenePostUrl.increment_id + '.html';
      currentPost.increment_id = datagenePostUrl.increment_id;
    }

    currentPost.modifiedAt = new Date();

    // console.log(currentPost);
    delete currentPost.editing;
    delete currentPost.editing_status;
    delete currentPost.start_editing;
    delete currentPost.post_revision;
    //?? update post là sao check nếu có _id thì update
    if(currentPost._id){
      // check nếu clickButton = true và posttype = draft thì set clickButton = false để không emit unlock post
      if(currentPost.clickButton && currentPost.posttype.type_code === 'draft'){
        currentPost.clickButton = false;
      }
      this.props.updatePost(currentPost);
    }
    else{
      this.props.createPost(currentPost);
    }
  }

  updateStatusTongHop(currentPost) {
    const contentHTML = document.createElement('div');
    contentHTML.innerHTML = currentPost.content
    const contentText = contentHTML.textContent;
    const contentWords = contentText.split(' ').length;
    let time = moment().format('HH:mm DD/MM/YYYY');
    if (currentPost.sourcename == null || currentPost.sourcename == '') {

      if (contentWords > 600) {
        currentPost.tonghop = true
        if (currentPost.royalties_editor_value == null) {
          currentPost.royalties_editor_value = "5e86142d8be8275b8c809196" // Id của royalties 120k
          currentPost.log_action += `${time} - Hệ thống - set nhuận => 120k,`;
        }
      } else {
        currentPost.tonghop = false
        if (currentPost.royalties_editor_value == null) {
          currentPost.royalties_editor_value = "5e86140c8be8275b8c809193" // id của royalties 50k
          currentPost.log_action += `${time} - Hệ thống - set nhuận => 50k,`;
        }
      }
    } else if (currentPost.royalties_editor_value == null) {
      currentPost.royalties_editor_value = "5e8613f18be8275b8c809191" // id của royalties 0
      currentPost.log_action += `${time} - Hệ thống - set nhuận => 0,`;
    }
  }

  // neu co post id:
  // nếu chuyển tab: update post
  // nếu bấm nút: 

  // draft => (draft, waiting)
  // waiting => (schedule, ready, draft)
  // ready => (trash, draft)
  // schedule => (ready, draft)
  // trash => (no action)

  // => draft => update post  (ready, schedule)
  // => !ready => check đủ điều kiên => update post
  //           => nếu không đủ đk =>

  // neu ko co post id:
  // -> chuyen tab => update currentpost
  // -> phu hop 4 dieu kien => tạo post
  // -> phu hợp dưới 4 đk => lưu storage => reload lại lấy từ storage

  actionForPost(passCondition, fromClickButton = false) {
    const { post: { currentPost }, fields } = this.props;

    if (currentPost.post_revision) {
      delete currentPost.post_revision;
    }

    this.handlePostRevision();

    if (!fromClickButton) {
      currentPost.editing_status = true;
      currentPost.editing = localStorage.get("_user");
      currentPost.start_editing = new Date();
      if (!currentPost.id) {
        if (passCondition.length >= 3) {
          this.props.createPost(currentPost);
        }
      } else {
        localStorage.set('_current_id', currentPost.id);
        this.actionBeforeUpdatePost(currentPost);
      }
    } else {
      currentPost.editing_status = false;
      currentPost.editing = null;
      currentPost.start_editing = null;
      if (!currentPost.id) {
        if (passCondition.length >= 3) {
          this.props.createPost(currentPost);
        }
      } else {
        this.actionBeforeUpdatePost(currentPost);
      }
    }

    if (localStorage.get('_newPost')) {
      localStorage.set('_newPost', currentPost);
    }
  }

  handlePostRevision() {
    const { post: { currentPost } } = this.props;
    const { postRevision } = this.state;
    const user = localStorage.get("_user");
    console.log("handlePostRevision");
    if (postRevision) {
      if (currentPost.id) {
        if (postRevision.revision.length === 0 || postRevision.revision[postRevision.revision.length - 1].content !== currentPost.content || postRevision.revision[postRevision.revision.length - 1].pr_type !== currentPost.pr_type) {
          if (postRevision.revision.length > 9) {
            postRevision.revision.shift();
          }
          ApiService.put(`/post-revisions/${postRevision.id}`, {
            revision: [
              ...postRevision.revision,
              {
                time: new Date(),
                content: currentPost.content,
                content_m: currentPost.content_m,
                title: currentPost.title,
                title_google: currentPost.title_google,
                description: currentPost.description,
                description_google: currentPost.description_google,
                contentpenname: currentPost.contentpenname.map(pen => pen.label).join(),
                contentdesigner: currentPost.contentdesigner,
                contentphoto: currentPost.contentphoto,
                contentsource: currentPost.contentsource,
                contentvideo: currentPost.contentvideo,
                category: currentPost.categories.map(cate => cate.name).join(),
                tag: currentPost.tags.map(tag => tag.label).join(),
                dimension: currentPost.dimensions.map(dimension => dimension.label).join(),
                img_hor: currentPost.img_hor,
                img_ver: currentPost.img_ver,
                user: user.email,
                ...(currentPost.pr_type != 0 && {
                  pr_type: currentPost.pr_type,
                  pragency: currentPost.pragency,
                  prprice: currentPost.prprice,
                  prdiscount: currentPost.prdiscount,
                })
              }
            ]
          }).then(data => {
            this.setState({
              postRevision: data
            })
          })
        }
      }
    }
  }

  handleSelectEditorType = (type, currentPost) => {
    this.setState({editor_type: type});
  }

  handleSelectPRType = (type, currentPost) => {
    this.setState({pr_type: type})
  }

  handlePr = value => {
    this.setState({ isPr: value });
  }

  callSuggestAI = data => {
    console.log(data);

  }

  handleSetScheduleDate = date => {
    this.setState({ scheduleDate: date });
  }

  handleCloseError = () => {
    this.setState({showModalError: false});
  }
  handleCloseErrorDowloadExternalIMG = () => {
    this.setState({
      showModalError: false,
      saveStatus: false,
    });
  }

  handleCheckExternalIMGError = () => {
    this.setState({
      checkExternalIMGError: false,
      listImageError: [],
    });
  }

  render() {

    let { currentPost, scheduleDate } = this.state;
    let readOnly = false;

    let layoutName = '';
    let editor_type = currentPost ? currentPost.editor_type : '';
    if (this.props.isMobile) {
      layoutName = 'layout-mobile';
    } else {
      if (currentPost && ['normal', 'video', 'podcast', 'short'].includes(editor_type)) {
        if (this.layoutPC3) {
          layoutName = 'layout-pc-3';
        } else {
          layoutName = 'layout-pc-2';
        }
      } else {
        layoutName = 'layout-pc';
      }
    }

    return (
      <>
      <IdleTimer
        ref={ref => { this.idleTimer = ref }}
        element={document}
        onActive={this.onActive}
        onIdle={this.onIdle}
        onAction={this.onAction}
        debounce={250}
        timeout={1000 * 60 * this.state.idleTimeMax} />

      <Modal show={this.state.showModal} onHide={this.handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Thông báo!</Modal.Title>
        </Modal.Header>
        <Modal.Body>Bạn đã không hoạt động trong khoảng thời gian dài, vui lòng refresh lại trang để cập nhật lại nội dung mới nhất.</Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={this.handleClose}>
            Đồng ý
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal show={this.state.showModalError} onHide={this.handleCloseError} centered>
        <Modal.Header closeButton>
          <Modal.Title>Thông báo!</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{maxHeight: '80vh'}}>
          <div style={{maxHeight: '70vh',overflow: 'hidden', overflowY: 'scroll'}}>
            <p>Lỗi khi tải ảnh, vui lòng thử lại. Nếu bạn đang copy ảnh từ một trang khác, vui lòng tải ảnh về máy sau đó tải lên lại.</p>
            {this.state.listImageError.length > 0 && this.state.listImageError.map(url => <img src={url} alt="ảnh lỗi" className='img-fluid ' style={{width: '100%', height: 'auto'}} />)}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={this.handleCloseErrorDowloadExternalIMG}>
            Đóng
          </Button>
        </Modal.Footer>
      </Modal>
        <div className={'content' + ((this.state.currentPost && this.state.currentPost.primary_category) ? ' ': ' step2 ')}>
          <div className={"card card-primary card-outline post-create " + (layoutName) + " " + (editor_type)}>
            <div className="card-header">
              <h3 className="card-title">
                <i className="fas fa-edit"></i>&nbsp; Bài viết {(this.state.currentPost && this.state.currentPost.posttype.title) ? `(${this.state.currentPost.posttype.title})` : ''}
              </h3>
              {this.state.currentPost && <ActionsPost setShowExitPrompt={this.setShowExitPrompt} listTab={this.state.listTab} layoutName={layoutName} condition={this.state.pass} handleUpdateStatus={this.updateStatusFromClickButton} postdata={this.state.currentPost} scheduleDate={this.state.scheduleDate} checkExternalIMGError={this.state.checkExternalIMGError}/>}
            </div>
            <div className="card-body">
              <div className="row">
                {(layoutName === 'layout-pc') &&
                  <div className={"col-12 " + (editor_type === 'special' || editor_type === 'mini' ? 'col-md-12 mb-4' : 'col-md-1')}>
                    <div className={"nav nav-tabs h-100 " + (editor_type === 'special' || editor_type === 'mini' ? 'flex-row' : 'flex-column')} id="vert-tabs-tab" role="tablist" aria-orientation="vertical">
                      <a className={`${_.join(this.state.listTab.category.classname, ' active ')}`} id="vert-tabs-5-tab" onClick={() => this.goTab(5)} data-toggle="pill" href="#vert-tabs-5" role="tab" aria-controls="vert-tabs-5" aria-selected="false">Chuyên mục</a>
                      <a className={`${_.join(this.state.listTab.title.classname, ' ')}`} id="vert-tabs-1-tab" onClick={() => this.goTab(1)} data-toggle="pill" href="#vert-tabs-1" role="tab" aria-controls="vert-tabs-1" aria-selected="false">Tiêu đề bài viết</a>
                      {currentPost &&
                      currentPost.posttype &&
                      currentPost.posttype.type_code !== "ready" && (
                        <a className="nav-link tab-require-status-success" id="vert-tabs-16-tab" onClick={() => this.goTab(16)} data-toggle="pill" href="#vert-tabs-16" role="tab" aria-controls="vert-tabs-16" aria-selected="false">Loại bài viết</a>
                      )}

                      <a className={`${_.join(this.state.listTab.penname.classname, ' ')}`} id="vert-tabs-14-tab" onClick={() => this.goTab(14)} data-toggle="pill" href="#vert-tabs-14" role="tab" aria-controls="vert-tabs-14" aria-selected="false">PR</a>

                      <a className={`${_.join(this.state.listTab.description.classname, ' ')}`} id="vert-tabs-2-tab" onClick={() => this.goTab(2)} data-toggle="pill" href="#vert-tabs-2" role="tab" aria-controls="vert-tabs-2" aria-selected="false">Tóm tắt nội dung</a>

                      <a className={`${_.join(this.state.listTab.content.classname, ' ')}`} id="vert-tabs-3-tab" onClick={() => this.goTab(3)} data-toggle="pill" href="#vert-tabs-3" role="tab" aria-controls="vert-tabs-3" aria-selected="false">Nội dung bài viết</a>

                    {(editor_type === 'mini' || editor_type === 'special') &&
                      <a className={`${_.join(this.state.listTab.content.classname, ' ')}`} id="vert-tabs-13-tab" onClick={() => this.goTab(13)} data-toggle="pill" href="#vert-tabs-13" role="tab" aria-controls="vert-tabs-13" aria-selected="false">Nội dung bài viết Mobile</a>
                    }

                      {currentPost &&
                        ((currentPost.posttype.type_code === 'schedule' || currentPost.posttype.type_code === 'waiting') ||
                          (currentPost.posttype.type_code === 'draft' && _user.canPublish)
                        ) &&
                        <a className="nav-link tab-require-status-success" id="vert-tabs-10-tab" onClick={() => this.goTab(10)} data-toggle="pill" href="#vert-tabs-10" role="tab" aria-controls="vert-tabs-10" aria-selected="false">Giờ xuất bản</a>
                      }

                      <a className={`${_.join(this.state.listTab.tag.classname, ' ')}`} id="vert-tabs-6-tab" onClick={() => this.goTab(6)} data-toggle="pill" href="#vert-tabs-6" role="tab" aria-controls="vert-tabs-6" aria-selected="false">Tag</a>

                      <a className={`${_.join(this.state.listTab.thumbnail.classname, ' ')}`} id="vert-tabs-4-tab" onClick={() => this.goTab(4)} data-toggle="pill" href="#vert-tabs-4" role="tab" aria-controls="vert-tabs-4" aria-selected="false">Thumbnail</a>

                      { (editor_type === 'mini' || editor_type === 'special') &&
                        <a className="nav-link tab-require-status-success" id="vert-tabs-12-tab" onClick={() => this.goTab(12)} data-toggle="pill" href="#vert-tabs-12" role="tab" aria-controls="vert-tabs-12" aria-selected="false">Ảnh Cover</a>
                      }

                      <a className={`${_.join(this.state.listTab.penname.classname, ' ')}`} id="vert-tabs-7-tab" onClick={() => this.goTab(7)} data-toggle="pill" href="#vert-tabs-7" role="tab" aria-controls="vert-tabs-7" aria-selected="false">Bút danh</a>

                      <a className={`${_.join(this.state.listTab.money.classname, ' ')}`} id="vert-tabs-8-tab" onClick={() => this.goTab(8)} data-toggle="pill" href="#vert-tabs-8" role="tab" aria-controls="vert-tabs-8" aria-selected="false">Nhuận bút</a>

                      {/* <a className={`${_.join(this.state.listTab.log.classname, ' ')}`} id="vert-tabs-9-tab" data-toggle="pill" href="#vert-tabs-9" role="tab" aria-controls="vert-tabs-9" aria-selected="false">Nhật ký</a> */}


                      <a className="nav-link tab-require-status-success" id="vert-tabs-11-tab" onClick={() => this.goTab(11)} data-toggle="pill" href="#vert-tabs-11" role="tab" aria-controls="vert-tabs-11" aria-selected="false">Tuỳ chỉnh</a>
                      <a className="nav-link" id="vert-tabs-15-tab" onClick={() => this.goTab(15)} data-toggle="pill" href="#vert-tabs-15" role="tab" aria-controls="vert-tabs-15" aria-selected="false">Dimension</a>
                    </div>
                  </div>
                }
              </div>
              <div className="row tab-content">
                <div className={(editor_type === 'special' || editor_type === 'mini') ? "col-xl-12 col-lg-12 col-md-12" : "col-xl-3 col-lg-4 col-md-12"}>
                  <div className="px-3 ">
                    <div className={"tab-pane fade show active step1"}
                      id="vert-tabs-5" role="tabpanel" aria-labelledby="vert-tabs-5-tab"
                    >
                      <CategoryTab 
                        checkRequireData={this.checkRequireData}
                        editorType={this.state.editor_type} 
                        layoutName={layoutName} 
                        checkClass={`${_.join(this.state.listTab.category.classname, ' ')}`} 
                      />
                    </div>
                    <div className={"tab-pane text-left fade " + (layoutName === 'layout-pc' ? '' : ' show active ')} id="vert-tabs-1" role="tabpanel" aria-labelledby="vert-tabs-1-tab">
                      <TitleTab checkRequireData={this.checkRequireData} typepage={this.props.typepage} layoutName={layoutName} checkClass={`${_.join(this.state.listTab.title.classname, ' ')}`} callsuggestai={() => this.callSuggestAI} />
                    </div>
                    <div className={"tab-pane fade " + (layoutName === 'layout-pc' ? '' : ' show active ')} id="vert-tabs-2" role="tabpanel" aria-labelledby="vert-tabs-2-tab">
                      <DescriptionTab checkRequireData={this.checkRequireData} layoutName={layoutName} checkClass={`${_.join(this.state.listTab.description.classname, ' ')}`} />
                    </div>
                    <div className={"tab-pane text-left fade " + (layoutName === 'layout-pc' ? '' : ' show active ')} id="vert-tabs-1" role="tabpanel" aria-labelledby="vert-tabs-1-tab">
                      <TitleAI checkRequireData={this.checkRequireData} typepage={this.props.typepage} layoutName={layoutName} checkClass={`${_.join(this.state.listTab.title.classname, ' ')}`} callsuggestai={() => this.callSuggestAI} />
                    </div>
                    <div className={"tab-pane fade "+ (layoutName === 'layout-pc' ? '' : ' show active')} id="vert-tabs-7" role="tabpanel" aria-labelledby="vert-tabs-7-tab">
                      <ContentCreatorTab checkRequireData={this.checkRequireData} isPr={this.state.isPr} layoutName={layoutName} checkClass={`${_.join(this.state.listTab.penname.classname, ' ')}`} />
                    </div>
                    <div className={"tab-pane fade "+ (layoutName === 'layout-pc' ? '' : ' show active')} id="vert-tabs-8" role="tabpanel" aria-labelledby="vert-tabs-8-tab">
                      <RoyaltiesTab 
                        checkRequireData={this.checkRequireData}
                        post={this.state.currentPost} 
                        layoutName={layoutName} 
                        checkClass={`${_.join(this.state.listTab.money.classname, ' ')}`} 
                        postRevision={this.state.postRevision}
                      />
                    </div>
                  </div>
                </div>
                <div className={(editor_type === 'special' || editor_type === 'mini') ? "col-xl-12 col-lg-12 col-md-12" : "col-xl-6 col-lg-8 col-md-12"}>
                  <div className="px-3">
                    <div className={"tab-pane fade "+ (layoutName === 'layout-pc' ? '' : ' show active')} id="vert-tabs-3" role="tabpanel" aria-labelledby="vert-tabs-3-tab">

                      {currentPost && <ContentTab handleCheckExternalIMGError={this.handleCheckExternalIMGError} channels={this.props.config ? this.props.config.channels : []} checkRequireData={this.checkRequireData} onSelectEditorType={this.handleSelectEditorType} content={currentPost} layoutName={layoutName} checkClass={`${_.join(this.state.listTab.content.classname, ' ')}`} listTab={this.state.listTab}/>}
                    </div>
                    
                    <div className={(editor_type != 'special' && editor_type != 'mini' ? "d-none" : "") + " tab-pane fade "+ (layoutName === 'layout-pc' ? '' : ' show active')} id="vert-tabs-13" role="tabpanel" aria-labelledby="vert-tabs-13-tab">
                          {currentPost && <ContentMobiTab handleCheckExternalIMGError={this.handleCheckExternalIMGError} channels={this.props.config ? this.props.config.channels : []} checkRequireData={this.checkRequireData} content={currentPost} layoutName={layoutName} checkClass={`${_.join(this.state.listTab.content_m.classname, ' ')}`} isPr={this.handlePr} listTab={this.state.listTab}/>}
                    </div>
                  </div>
                </div>
                <div className={(editor_type === 'special' || editor_type === 'mini') ? "col-xl-12 col-lg-12 col-md-12" : "col-xl-3 col-lg-4 col-md-12"}>
                  <div className="px-3">
                    <div className={"tab-pane fade "+ (layoutName === 'layout-pc' ? '' : ' show active')}
                      id="vert-tabs-10" role="tabpanel" aria-labelledby="vert-tabs-10-tab"
                    >
                      <GioXuatBanTab  currentPost={currentPost} setScheduleDate={this.handleSetScheduleDate} _user={_user} />
                    </div>
                    {currentPost &&
                    currentPost.posttype &&
                    currentPost.posttype.type_code !== "ready" && (
                        <div className={"tab-pane fade "+ (layoutName === 'layout-pc' ? '' : ' show active')}
                          id="vert-tabs-16" role="tabpanel" aria-labelledby="vert-tabs-16-tab"
                        >
                          <EditorTypeTab content={currentPost} onSelectEditorType={this.handleSelectEditorType} checkRequireData={this.checkRequireData} checkClass={`${_.join(this.state.listTab.content_m.classname, ' ')}`} listTab={this.state.listTab} layoutName={layoutName}/>
                        </div>
                    )}
                    
                    <div className={"tab-pane fade "+ (layoutName === 'layout-pc' ? '' : ' show active')}
                      id="vert-tabs-14" role="tabpanel" aria-labelledby="vert-tabs-14-tab"
                    >
                      <PRTab onSelectPRType={this.handleSelectPRType}  isPr={this.handlePr}  pr_type={this.state.pr_type} post={currentPost} checkRequireData={this.checkRequireData} layoutName={layoutName} checkClass={`${this.state.listTab.pr ? _.join(this.state.listTab.pr.classname, ' ') : null }`} />
                    </div>

                    

                    <div className={"tab-pane fade "+ (layoutName === 'layout-pc' ? '' : ' show active')}
                      id="vert-tabs-6" role="tabpanel" aria-labelledby="vert-tabs-6-tab"
                    >
                      <TagTab checkRequireData={this.checkRequireData} layoutName={layoutName} checkClass={`${_.join(this.state.listTab.tag.classname, ' ')}`} />
                    </div>
                    <div className={"tab-pane fade "+ (layoutName === 'layout-pc' ? '' : ' show active')} id="vert-tabs-4" role="tabpanel" aria-labelledby="vert-tabs-4-tab">
                      {currentPost && <ThumbnailTab channels={this.props.config ? this.props.config.channels : []} checkRequireData={this.checkRequireData} editor_type={currentPost.editor_type} content={currentPost} layoutName={layoutName} checkClass={`${_.join(this.state.listTab.thumbnail.classname, ' ')}`} />}
                    </div>
                    { (editor_type === 'mini' || editor_type === 'special') &&
                      <div className={"tab-pane fade " + (layoutName === 'layout-pc' ? '' : ' show active') + (layoutName === 'layout-pc-2' ? ' col-12' : '')} id="vert-tabs-12" role="tabpanel" aria-labelledby="vert-tabs-12-tab">
                        {this.state.currentPost && <CoverTab channels={this.props.config ? this.props.config.channels : []} content={this.state.currentPost} layoutName={layoutName} />}
                      </div>
                    }
                    <div className={"tab-pane fade "+ (layoutName === 'layout-pc' ? '' : ' show active')} id="vert-tabs-11" role="tabpanel" aria-labelledby="vert-tabs-11-tab">
                      {this.state.currentPost &&
                        <>
                          <OptionsTab content={this.state.currentPost} layoutName={layoutName} role={_user.role.type} nhaycamInfo={this.state.nhaycamInfo}/>
                          <ShareEditPermissionTab currentPost={this.state.currentPost} />
                        </>
                      }
                    </div>
                    <div className={"tab-pane fade "+ (layoutName === 'layout-pc' ? '' : ' show active')}
                      id="vert-tabs-15" role="dimensionpanel" aria-labelledby="vert-tabs-15-tab"
                    >
                      <DimensionTab checkRequireData={this.checkRequireData} layoutName={layoutName}  checkClass={`${this.state.listTab.dimension ? _.join(this.state.listTab.dimension.classname, ' ') : null}`}/>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {this.state.saveStatus &&
          <div className="saveblock">
            <div className="saveblock-content">
              <p>Đang xử lý...</p>
              <div className="spinner-border text-primary" role="status">
                <span className="sr-only">Loading...</span>
              </div>
            </div>
          </div>
        }
      </>
    );

  }
};


const selector = formValueSelector('formPostEdit');
PostContent = reduxForm({
  form: 'formPostEdit'
})(PostContent)

export default connect(store => {
  return {
    login: store.loginInfo,
    config: store.config,
    post: store.post,
    fileUpload: store.fileUpload,
    form: store.formPostEdit,
    router: store.router,
    fields: selector(store, 'title', 'title_google', 'url', 'keyword', 'sourcename', 'description_google', 'description', 'prprice', 'prdiscount', 'title_ai', 'description_ai')
  };
}, dispatch => {
  return {
    setCurrentPost: (value) => { dispatch(postActions.setCurrentPost(value)) },
    uploadFile: (value) => { dispatch(fileActions.uploadFile(value)) },
    createPost: (value) => { dispatch(postActions.createPost(value)) },
    updatePost: (value) => { dispatch(postActions.updatePost(value)) },
    changeTab: (value) => { dispatch(postActions.changeTab(value)) },
    changeFieldValue: (field, value) => { dispatch(change('formPostEdit', field, value)) },
  }
})(PostContent)
